/* eslint-disable */
<template>
  <div class="h-screen flex w-full bg-img" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-1/4 mx-auto self-center">
      <vx-card>
        <div>
          <div class="vx-row">
            <div class="vx-col sm:w-full md:w-full lg:w-full mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">I9 Advisory - Sistema de Crédito</h4>
                  <p>Recuperação de senha</p>
                </div>
                <vs-input
                  type="password"
                  name="password"
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="Nova senha"
                  v-model="password"
                  class="w-full mt-6 no-icon-border"/>

                <vs-input
                  type="password"
                  name="password2"
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="Repita a senha"
                  v-model="password2"
                  class="w-full mt-6 no-icon-border" />

                <vs-alert v-if="error" color="danger" active="true" class="my-5">
                  <div class="flex">&nbsp;{{ error }}</div>
                </vs-alert>

                <div class="flex flex-wrap justify-between mt-5"></div>

                <div class="flex mb-5 float-right">
                  <vs-button @click="submit">Alterar</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  props:{
    guid: String
  },
  data () {
    return {
      password: '',
      password2: '',
      error: null
    }
  },
  methods: {
    submit () {

      this.error = null

      if (this.password != this.password2) {
        this.error = 'As senhas não conferem.'
        return
      }

      const passwordForm = {
        'guid': this.guid,
        'newPassword': this.password
      }

      this.loading = true
      const url = `${process.env.VUE_APP_AUTH_API}/api/v1/password-recovery`

      axios.put(url, passwordForm)
        .then((response) => {
          if (response) {
            if (response.status === 200) {
              this.$router.push({ path: '/' })
            }
          }
        })
        .catch(() => {
          this.error = 'Erro. Tente novamente mais tarde.'
        })
    }
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #1551b1;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
